import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-page-not-found',
  template: `
    <div
      class="d-flex flex-column align-items-center bg-white px-4 pt-5 text-center"
      aria-labelledby="not-found-title"
    >
      <img
        ngSrc="assets/img/logo/Nobina_logo_RGB.svg"
        alt="Nobina"
        width="370"
        height="230"
        class="mb-4"
        style="max-width: 280px; width: 100%;"
      />

      <div class="d-flex flex-column align-items-center mb-4">
        <h1 id="not-found-title" class="display-1 font-weight-bold text-success mb-2">404</h1>
        <h2 class="h4 font-weight-semibold text-secondary mb-2" i18n="@@page-not-found.title">Sidan hittades inte</h2>
        <p class="text-muted" style="max-width: 28rem;" i18n="@@page-not-found.description">Sidan du letar efter finns inte eller kan ha flyttats.</p>
      </div>

      <button type="button" class="btn btn-primary" (click)="navigateHome()" i18n="@@page-not-found.go-to-home">Gå till startsidan</button>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundComponent {
  private _document = inject(DOCUMENT);

  navigateHome(): void {
    this._document.location.href = '/';
  }
}
